import React, { useEffect, useState } from "react";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import TitlePage from "../../../components/TitlePage"
import ConsultaGiroSSMA from "../../../../lib/json/consultas/GiroSSMA.json"
import ConsultaTipoInspecao from '../../../../lib/json/consultas/TipoInspecao.json'
import ConsultaCentroCusto from '../../../../lib/json/consultas/CentroCustoSSMA.json'
import ResponsiveDataTable from "../../../components/DataTable";
import LoadingSpinner from "../../../components/LoadinSpinner";
import { ConsultaAPI } from "../../../../backend/ConsultaAPI";
import { RetornaUsuarioLogado, SucessoMsg } from "../../../contents/VariaveisGlobais";
import { ConsumoAPI_DELETE } from "../../../../backend/ConsumoAPI";
import { useNavigate } from "react-router-dom";
import InputGeral from "../../../components/InputGeral/Index";
import { format, startOfYear } from "date-fns";
import SelectDinamico from "../../../components/SelectDinamico";
import { usePopUp } from "../../../components/BootBox";

function formataStatusGiro(item){
    const status = item.value === 'undefined' ? 'Elaboração' : item.value
    return status
}

function ListaGiroSSMA(){
    const navigate = useNavigate();
    const usuarioLogado = RetornaUsuarioLogado();
    const currentDate = new Date()
    const firstDayOfYearDate = startOfYear(currentDate);

    const [dateDe, setDateDe] = useState(format(firstDayOfYearDate, 'yyyy-MM-dd'));
    const [dateAte, setDateAte] = useState(format(currentDate, 'yyyy-MM-dd'));
    const [campoTipoInspecao, setCampoTipoInspecao] = useState({value: '', label: ''});
	const [campoCentroCusto, setCampoCentroCusto] = useState({value: '', label: ''});
	const [filtroCentroCusto, setFiltroCentroCusto] = useState();
	var [consultaCentroCusto, setConsultaCentroCusto] = useState();

    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    
    const columns = [
        {
            Header: 'ID',
            accessor: 'Id',
        },
        {
            Header: 'Data Emissão',
            accessor: 'DataHora',
        },
        {
            Header: 'Empresa/Filial',
            accessor: 'Filial',
        },
        {
            Header: 'Centro de Custo',
            accessor: 'CentroCusto',
        },
        {
            Header: 'Tipo de Inspeção',
            accessor: 'TipoInspecao',
        },
        {
            Header: 'Status',
            accessor: 'Status',
            Cell: formataStatusGiro
        }
    ];
    
    var [carregar, setCarregar] = useState(false);
    var consultaDefault  = ConsultaGiroSSMA.consulta;
    var [data, setData]   = useState([]);
    
    useEffect(() => {
		let consultaCC = ConsultaCentroCusto.consulta + ' WHERE 1 = 1 '
        let filtraCentroCusto = ''
        let filtraEmpresa = ''
        usuarioLogado.parametrosEmpresas.forEach((empresa) => {
            const parametroEmpresa = usuarioLogado.parametrosEmpresas.filter((e) => e.empresaFilial.substr(0, 4) === empresa.empresaFilial);
            filtraEmpresa += empresa.empresaFilial + "','";
    
            if (parametroEmpresa.length > 0) {
                if (parametroEmpresa[0].centroCusto.length > 0) {
                    filtraCentroCusto += parametroEmpresa[0].centroCusto.join("','") + "','";
                }
            }
        });

        if (filtraEmpresa)
            consultaCC += " AND '01' + LEFT(CTT_FILIAL,2) IN ('" + filtraEmpresa.slice(0,-3) + "') "
        if (filtraCentroCusto)
            consultaCC += " AND CTT_CUSTO IN ('" + filtraCentroCusto.slice(0,-3) + "') "

        setFiltroCentroCusto(filtraCentroCusto)
        setConsultaCentroCusto(consultaCC)
        // loadListaGiroSSMA();
    }, []);

    useEffect(() => {
        if (filtroCentroCusto){
            loadListaGiroSSMA();
        }
        else if (consultaCentroCusto && !filtroCentroCusto){
            loadListaGiroSSMA();
        }
    },[filtroCentroCusto, consultaCentroCusto])

    // Processa consulta do grid
    const loadListaGiroSSMA = async () => {
        setCarregar(true);
        const consultaLista = consultaDefault + ` WHERE DataHora BETWEEN '${dateDe} 00:00:00' AND '${dateAte} 23:59:59' ` +
                ( campoTipoInspecao.value ? " AND TipoInspecaoId = '" + campoTipoInspecao.value + "'" : "") +
				( campoCentroCusto.value ? " AND CentroCustoId = '" + campoCentroCusto.value + "'" : "") +
				( filtroCentroCusto ? " AND CentroCustoId IN ('" + filtroCentroCusto.slice(0,-3) + "')" : "") +
                `  AND RIGHT(PSMA.FilialId,4) IN ('${usuarioLogado.empresasUsuario.join("','")}') `;
                
        var retConsulta = await ConsultaAPI( consultaLista );
        
        setData(retConsulta.data);
        setCarregar(false);
    }

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.values.Id}`)
    }

    const handleVisualizar = (row) =>{
        navigate(`./Visualizar/${row.values.Id}`)
    }
    
    const handleExcluir = async (row) => {
        const idRow = row.values.Id;
        const Mensagem = `Tem certeza que deseja excluir o registro ${idRow + ' - Empresa: ' + row.values.Filial+ ' / Centro de Custo: ' + row.values.CentroCusto}?`
        
        DisparaBootBox('Confirma Exclusão ?', Mensagem, null, idRow, handleExcluirConfirm)
    };

    const handleExcluirConfirm = async(id) => {
        FechaBootBox()
        try {
            setCarregar(true);

            const rota = 'giroSSMA/' + id;
            const retConsumo = await ConsumoAPI_DELETE(rota);

            SucessoMsg(retConsumo.description);
            loadListaGiroSSMA();
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
        }
    };
    
    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage text="Giro SSMA"/>
            </Col>
            </Row>
        <Row>
            <Col md="3" xs="12">
                <InputGeral
                    label="Emissão de"
                    tipo='date'
                    value={dateDe}
                    onChange={(e) => setDateDe(e.target.value)}
                />
            </Col>
            <Col md="3" xs="12">
                <InputGeral
                    label="Emissão Ate"
                    tipo='date'
                    value={dateAte}
                    onChange={(e) => setDateAte(e.target.value)}
                />
            </Col>
            <Col md="6" xs="12">
                <SelectDinamico 
                    label="Tipo Inspeção"
                    consulta={ConsultaTipoInspecao.consulta}
                    tabela={ConsultaTipoInspecao.tabelas}
                    cValue="Id"
                    cText='Id + " - " + item.Nome'
                    isMultiplo={false}
                    campoValue={campoTipoInspecao}
                    value={campoTipoInspecao}
                    onchange={(e) => setCampoTipoInspecao(e)}
                    showNoFilter={false}
                />
            </Col>
			<Col md="6" xs="12">
                <SelectDinamico 
                    label="Centro de Custo"
                    consulta={consultaCentroCusto}
                    tabela={ConsultaCentroCusto.tabelas}
                    cValue="CTT_CUSTO"
                    cText='CTT_CUSTO + " - " + item.CTT_DESC01'
                    isMultiplo={false}
                    campoValue={campoCentroCusto}
                    value={campoCentroCusto}
                    selectOptionUnique={true}
                    showNoFilter={false}
                    onchange={(e) => setCampoCentroCusto(e)}
                />
            </Col>
            <Col md="3" xs="12">
                <Form.Group as={Col} className="md-2" controlId="formGridBuscar">
                    <InputGroup size="md" className="mb-3">
                        <Button variant="outline-primary" type="submit" onClick={loadListaGiroSSMA}>
                            Buscar
                        </Button>
                    </InputGroup>
                </Form.Group>
            </Col>
        </Row>
        
        <Row>
            { data.length > 0 &&
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons= {[
                            {isVisual: true, action: handleVisualizar, label: "Visualizar", icone: "MdOutlinePreview", style: "light"}, 
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote", regraExclude: "(row.values.Status === 'Concluído' || row.values.Status === 'Concluído com Ressalvas')"}, 
                            {isExcluir: true, action: handleExcluir, label: "Excluir", icone: "MdPlaylistRemove", style: "danger", regraExclude: "(row.values.Status === 'Concluído' || row.values.Status === 'Concluído com Ressalvas')"}
                        ]}
                    />
                </Col>
            }
        </Row>
        </>
    );
}

export default ListaGiroSSMA;